import { jsx as _jsx } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgClose = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
  })
});
export default SvgClose;